import React from "react";
import preview from "../../../../assets/portfolio/palace/preview.png";

export default function Palace() {
	return (
		<div
			style={{
				margin: "0",
				marginTop: "4rem",
				width: "calc(100% - 2rem)",
			}}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Palace Casino &amp; Resort{" "}
			</h2>
			<h3>Player Portal</h3>
			<p>Website redesign with an integrated API driven player portal.</p>
			<div
				style={{
					width: "100%",
					height: "600px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#C89702",
				}}>
				<img
					src={preview}
					alt="Player point portal for casino"
					style={{ width: "200%" }}
				/>
			</div>
		</div>
	);
}
